export const mockDepartmentFields = [
  {
    name: "department_name",
    type: "text",
    label: "Department Name",
    gridColumn: "span 4",
  },
];
